<template>
  <div v-show="value" ref="dialog" class="act_alert_dialog">
    <img
      src="https://vipcdn.mgtv.com/lego/20211223/lego/2b1038bc63d811ecbe25005056921140.png"
      class="close"
      @click="handleAction('cancel')"
    />

    <div class="content">
      <div class="h1">授权登录</div>
      <div v-html="title" v-if="title"></div>
      <!-- <div class="gz" @click="agreeGz">
        <span :class="['select-icon', agreeState ? 'active' : '']"></span
        ><span>我已阅读 <em @click.stop="showGz">《用户协议》</em> 并同意授权</span>
      </div> -->
      <div class="submit" @click.prevent="handleAction('confirm')" v-if="button">{{ button }}</div>
    </div>
  </div>
</template>
<script>
import { createNamespace } from 'vant/lib/utils';
import { PopupMixin } from 'vant/lib/mixins/popup';
const [createComponent] = createNamespace('popup');
import click_handler from '../../../tools/mgtv/click';

export default createComponent({
  name: 'ActPhoneDialog',
  mixins: [PopupMixin],
  props: {
    callback: Function,
    overlay: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    lockOnScroll: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: `<p>规则</p><p>规则</p>`
    },
    button: {
      type: String,
      default: '确认'
    },
    hasMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      agreeState: false
    };
  },
  methods: {
    handleAction(action) {
      // if(action == 'confirm'){
      //   if(this.hasMobile && !this.agreeState){
      //     window.$toast('请同意我已阅读《用户协议》并同意授权')
      //     return
      //   }
      // }
      this.$emit('input', false);
      this.$emit(action);
      this.callback && this.callback(action);
    },
    showGz() {
      click_handler('展示用户协议', () => {
        window.$act_alert_dialog.show({
          title: `<div style="text-align: center">芒果TV授权用户协议</div>`,
          button: '我知道了'
        });
      });
    },
    agreeGz() {
      click_handler(`${this.agreeState ? '未同意规则' : '同意规则'}`, () => {
        this.agreeState = !this.agreeState;
      })
    },
  },
  mounted() {},
  watch: {},
  computed: {}
});
</script>

<style lang="stylus" scoped>
@import "../../../share/mixins.styl"

.act_alert_dialog
  padding 0.4rem .3rem .5rem .3rem
  background white
  center()
  border-radius 0.32rem
  color #717171
  position fixed !important

.close
  position absolute
  top 0rem
  right 0
  width .54rem
  height .54rem
  z-index 2
  box-sizing content-box
  padding .2rem

.content
  overflow hidden
  position relative
  width: 6rem
  text-align: center
  font-size: 0.28rem
  line-height: 0.4rem
  color: #333333;
  font-weight: 400;
  .h1
    text-align: center
    height: 0.48rem;
    font-size: 0.36rem;
    font-weight: 600;
    color: #333333;
    line-height: 0.48rem;
    margin-bottom: 0.2rem
  .title
    width 100%
    text-align center
    font-size .4rem
    margin-bottom .4rem
    width: 5.2rem;
    font-size: 0.28rem;
    font-weight: 400;
    color: #333333;
    line-height: 0.4rem;
    text-align: center
  .submit
    background-size cover
    width: 5.2rem;
    height: 0.88rem;
    background: #FF5F00;
    height .84rem
    text-align center
    color white
    margin .4rem auto 0 auto
    font-size .3rem
    padding-top .16rem
    border-radius: 0.5rem
    line-height: 0.54rem
    font-size: 0.32rem
  .gz
    height: 0.44rem;
    font-size: 0.24rem;
    color: #333333;
    line-height: 0.44rem;
    margin-top: 0.32rem;
    text-align: left
    span
      display: inline-block
      vertical-align: middle
      em
        font-style: normal
    .select-icon
      width: 0.32rem
      height: 0.32rem
      background-image: url('https://vipcdn.mgtv.com/lego/20211223/lego/6153755c63eb11ecbd3d005056921140.png')
      background-size: contain;
      background-repeat: no-repeat;
      margin-right: 0.08rem
      &.active
        background-image: url('https://vipcdn.mgtv.com/lego/20211223/lego/7d53ce3263eb11ec9055005056921140.png')

.inline-block
  display inline-block
</style>
